export const baseURL = "https://wawe.codderlab.com";
export const secretKey = "GRBqJqoVrWo0sdEJTRvBnnizXQi8AhT8";
export const  projectName = "Wawe";
